<template>
	<div class="l-container l-container--full-width l-container--full-width@mobile">
		<Carousel
			v-if="album.events.length > 0"
			:cells="album.events"
			button-offset="35%"
		>
			<template #cell="{cell}">
				<EventCard
					v-bind="EventCardProps(cell, { large: false, hidePaymentRestriction: false, openInNewTab: true })"
				/>
			</template>
		</Carousel>
		<EmptyState
			v-else
			:text="$I18n.trans('arena.no_results')"
		/>
	</div>
</template>

<script>
import EmptyState from '@js/components/EmptyState';
import Carousel from '@js/components/Carousel';
import { EventCardProps } from '@shared/components/EventCard/EventCardProps';
import EventCard from '@shared/components/EventCard/EventCard';

export default {
	name:       'ViewAlbumEmbedCarousel',
	components: { Carousel, EventCard, EmptyState },
	props:      {
		album: {
			type:     Object,
			required: true,
		},
	},
	data() {
		return {
			EventCardProps,
		};
	},
};
</script>

<style>

</style>
